const FIELPET_FAVICON = "/assets/icon/favicon.png";

const FALLBACK_FAVICON =
  "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f436.png";

export const updateFavicon = (brandName: string, iconUrl?: string) => {
  let finalUrl: string;

  // 👉 Caso especial: FielPet usa favicon local del proyecto
  if (brandName.trim().toLowerCase() === "fielpet") {
    finalUrl = FIELPET_FAVICON;
  } else {
    // 👉 Otras marcas: usar logoUrl o fallback remoto
    finalUrl = iconUrl || FALLBACK_FAVICON;
  }

  // 1. Borrar todos los favicons existentes
  const existing = document.querySelectorAll(
    "link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']"
  );
  existing.forEach((e) => e.parentNode?.removeChild(e));

  // 2. Crear favicon estándar
  const icon = document.createElement("link");
  icon.rel = "icon";
  icon.type = "image/png";
  icon.href = `${finalUrl}?v=${Date.now()}`;
  document.head.appendChild(icon);

  // 3. Crear favicon Apple iOS
  const apple = document.createElement("link");
  apple.rel = "apple-touch-icon";
  apple.href = `${finalUrl}?v=${Date.now()}`;
  document.head.appendChild(apple);
};
